import { useState } from "react";
import { registerUser, loginUser, logoutUser, saveUserPreference } from "../../utils/firebase";
import { useNavigate } from "react-router-dom";
import NavBar from "../navbar/navbar.component";
import Toast from "../toast/toast.component"
import { useMyData } from '../../context/data-context.component';
import './auth-form.styles.css'
import GlitchyBackground from "../glitchy-background/glitchy-background.component";
  import { GoogleAuthProvider, signInWithPopup } from "firebase/auth";
import { auth, ensureUserDoc } from "../../utils/firebase";


export default function AuthForm() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [user, setUser] = useState(null);
  // const [error, setError] = useState("");
  const [isRegister, setIsRegister] = useState(false);
  const [showModal, setShowModal] = useState(false)
  const [toastMessage, setToastMessage] = useState("");
  const [loginError, setLoginError] = useState(false)
  const [ignoreError, setIgnoreError] = useState(false);

  

  const [choice, setChoice] = useState("");

     const { loadFullUserProfile } = useMyData();
  

  const showToast = (msg) => {
  setToastMessage(msg);
    };


  const navigate = useNavigate()

  const handleSubmit = async (e) => {
  e.preventDefault();
  setToastMessage("");
  setTimeout(() => {
    setEmail("");
    setPassword("");
  }, 3000)

  try {
    let loggedUser;

    if (isRegister) {
      loggedUser = await registerUser(email, password);
      setShowModal(true)
    } else {
      loggedUser = await loginUser(email, password);
      navigate("/")
    }
    setUser(loggedUser);
    
    
  } catch (err) {
    console.log(err.code)
    switch (err.code) {
      case "auth/email-already-in-use":
        showToast("Already Registered");
        break;
      case "auth/invalid-email":
        showToast("Invalid Email");
        break;
      case "auth/weak-password":
        showToast("Weak Password");
        break;
      case "auth/user-not-found":
      case "auth/wrong-password":
      case "auth/invalid-credential":
        showToast("Incorrect Email/Password.");
        break;
      default:
        showToast("Unexpected Error");
        break;
    }
  }
};

const handleOkay = async () => {
  try {
    await saveUserPreference(choice);
    navigate("/");  // stays here — because it’s a UI action
  } catch (err) {
    showToast("Failed to save preference.");
    setTimeout(() => {
    navigate("/")
  }, 2000)
  }
};

    const handleSignIn = async () => {

         const provider = new GoogleAuthProvider();
          provider.setCustomParameters({
            prompt: 'select_account'
          });


              const isInAppBrowser = () => {
              const ua = navigator.userAgent || navigator.vendor || window.opera;
              return /FBAN|FBAV|Instagram|Line|Zalo|TikTok|Snapchat|Twitter/i.test(ua);
            };

              if (isInAppBrowser() && ignoreError) {
                setLoginError(true);
                return;
              }

          try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;

            const isNewUser = await ensureUserDoc(user);
            await loadFullUserProfile(user);

            if (isNewUser) {
              setShowModal(true);
            } else {
              navigate('/');
            }
          } catch (error) {
            console.error("Error signing in:", error);
          }
        };

        function SignInButton() {

return (
  <button
  type="button"
  onClick={handleSignIn}
  style={{
    backgroundColor: "#a80000", // Google red
    color: "white",
    padding: 10,
    borderRadius: "10px",
    width: "60%",
    fontSize: "18px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    gap: "8px",
  }}
>
  {/* Google "G" SVG logo */}
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 533.5 544.3"
    width="35"
    height="35"
    fill="white"
    style={{ transform: "translateX(8px)" }}
  >
    <path d="M533.5 278.4c0-17.4-1.5-34.1-4.3-50.4H272v95.5h146.9c-6.3 34-25 62.8-53.7 82v68h86.8c50.8-46.8 80-115.7 80-195.1z" fill="#4285f4"/>
    <path d="M272 544.3c72.7 0 133.7-24 178.3-65.1l-86.8-68c-24.1 16.1-55 25.7-91.5 25.7-70.3 0-130-47.4-151.4-111.1H29v69.9C73.3 486.3 165.7 544.3 272 544.3z" fill="#34a853"/>
    <path d="M120.6 322.1c-5.5-16.3-8.6-33.7-8.6-51.6s3.1-35.3 8.6-51.6V149H29c-17.7 35.7-29 75.9-29 121s11.3 85.3 29 121l91.6-69.9z" fill="#fbbc04"/>
    <path d="M272 107.7c39.5 0 75 13.6 103 40.5l77.3-77.3C405.4 24.9 344.4 0 272 0 165.7 0 73.3 58 29 149l91.6 69.9c21.4-63.7 81.1-111.2 151.4-111.2z" fill="#ea4335"/>
  </svg>

  Sign in with Google
</button>
  );
}

   const dismissFunction = () => {
                setIgnoreError(true);
                setLoginError(false);
                handleSignIn();
              };


  const handleLogout = async () => {
    await logoutUser();
    setUser(null);
  };

  return (
    <>
    <NavBar />
    <div className="af-wrapper" style={{ position: 'relative', width: '100%', minHeight: '100vh' }}>

    <GlitchyBackground/>
       {showModal && (
        <div className="intro-modal">
          <p>Welcome! A verification email has been sent.</p>
            <h2>Let me know what are you most interested in.</h2>
              <label><input type="radio" name="interest" value="videos" onChange={() => setChoice("videos")} /> Learning with videos.</label><br />
              <label><input type="radio" name="interest" value="cards" onChange={() => setChoice("vocab")} /> Studying with cards.</label><br />
              <label><input type="radio" name="interest" value="games" onChange={() => setChoice("games")} /> Playing word games.</label><br />
              <button onClick={handleOkay} style={{ marginTop: 20, display: "block", margin: "20px auto"  }}>Continue
          {/* onClick={handleOkay}>Submit */}
          </button>
        </div>
      )}
       {loginError && (
        <div className="login-modal">
          <p>Google login may not work in this browser.  Please open Chrome or Safari.</p>
            <a
                href="https://theenglishinterface.com"
                target="_blank"
                rel="noopener noreferrer"
                style={{display: "block",marginTop: "15px",textAlign: "center", fontSize: 32,  color: "#55009a", textDecoration: "underline"}}>Open in Browser
            </a>
        <button
            onClick={dismissFunction}
            style={{ marginTop: 20, display: "block", margin: "20px auto", padding: "8px 16px"}}>Dismiss
        </button>
        </div>
      )}
      {toastMessage && (
        <Toast
          key={toastMessage}
          message={toastMessage}
          onClose={() => setToastMessage("")}
        />
      )}
      {user ? (
        <div>
          <p>Welcome, {user.email}</p>
          <button onClick={handleLogout}>Log out</button>
        </div>
      ) : (
        <>
        <div className = "af-form-house">
          
        <form onSubmit={handleSubmit}>
          <h1 className = {"af-welcome-text"}>Login Page</h1>

          <input
            type="email"
            placeholder="Email"
            value={email}
            required
            onChange={(e) => setEmail(e.target.value)}
            style={{ width: "100%", marginBottom: 8, padding: 8, backgroundColor: "#fff7a4", borderRadius: "8px"}}
          />

          <input
            type="password"
            placeholder="Password"
            value={password}
            required
            onChange={(e) => setPassword(e.target.value)}
            style={{ width: "100%", marginBottom: 8, padding: 8, backgroundColor: "#fff7a4", borderRadius: "8px"}}
          />
          
          <button type="submit" className = "email-login-button"
          >
            {isRegister ? "Register" : "Login"}
          </button>

          <p
            onClick={() => {
              setIsRegister(!isRegister);
              setToastMessage("");
            }}
            className = "or-option"
          >
            {isRegister ? (
              <>
                Click to Log in <br /> <span>OR</span>
              </>
            ) : (
              <>
                Click to Register <br /> <span>OR</span>
              </>
            )}
          </p>
          <div style={{ display: "flex", justifyContent: "center" }}>
                 {/* marginTop: "20px"  */}
        {/* <p style={{ marginBottom: 8 }}
        >or
        </p> */}
        <SignInButton/>
        

      </div>

        </form>
        </div>
            
      </>
      )}
      </div>
    </>
  );
}